<template>
  <div id="sidebar">
    <template v-for="(item, index) in list">
      　　　    
      <!-- 标题 -->
      <template v-if="item.children.length">
        <el-submenu :key="index" :index="item.index">
          <template :index="item.index" slot="title">
        
            <span @click="dianji(item)" :class="{'hh-active':item.path===$route.path}">{{ item.name }}</span>
          </template>
          <el-menu-item-group>
            <sideBar :list="item.children"></sideBar>
          </el-menu-item-group>
        </el-submenu>
      </template>
      　　　
      <!-- 选项 -->
      <template v-else>
        <el-menu-item :key="index" :index="item.index"  :default-openeds="openeds">
          <span @click="dianji(item)" :class="{'hh-active':item.path===$route.path}">{{ item.name }}</span>
        </el-menu-item>
      </template>
    </template>
  </div>
</template>
<script>
export default {
  name: "sideBar",
  props: {
    list: Array,
  },
  data() {
     return {
     openeds:['menu2']
     }
  },
  methods: {
    dianji(item) {

      this.$router.push({ path: item.path }).catch((err) => {});
    },
  },
};
</script>
<style>
::v-deep .mapTipWindow li {
    font-size: 18px;
}
.el-menu {
  border-right: none;
}
.el-menu-item {
  border-bottom: 1px solid #eeeeee;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #999999;
  line-height: 56px;
  cursor: pointer;
  padding-left: 0 !important;
  background: none;
}
.el-submenu__title {
  border-bottom: 1px solid #eeeeee;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #999999;
  line-height: 56px;
  cursor: pointer;
  padding: 0 !important;
  background: none;
  border-bottom-color: #eeeeee !important;
}
li {
  padding-left: 0 !important;
}
.el-menu-item.is-active {
  color: #999999;
   background-color: #fff;

}
.el-menu-item:hover {
    background-color: #fff;
}
.hh-active {
  color: #b78c0d !important;
}
.el-menu--inline {
  font-size: 14px !important;
}
.el-menu-item-group__title {
  padding: 0;
}
</style>